<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>
    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div class="page-header">
          <div class="content-page-header">
            <h5>Profit and Loss</h5>
            <div class="list-btn">
              <ul class="filter-list">
                <li>
                  <a class="btn-filters w-auto popup-toggle"
                    ><span><i class="feather feather-filter"></i></span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- /Page Header -->

        <!-- Add Asset -->
        <div class="toggle-sidebar">
          <div class="sidebar-layout-filter">
            <div class="sidebar-header">
              <h5>Filter</h5>
              <a href="javascript:;" class="sidebar-closes"
                ><i class="fa-regular fa-circle-xmark"></i
              ></a>
            </div>
            <div class="sidebar-body">
              <b-form action="#" autocomplete="off">
                <div class="accordion" id="accordionMain1">
                  <a
                    href="javascript:void(0);"
                    class="w-100"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    <div class="card-header-new" id="headingOne">
                      <h6 class="filter-title">
                        Profit and Loss
                        <span class="float-end"
                          ><i class="fa-solid fa-chevron-down"></i
                        ></span>
                      </h6>
                    </div>
                  </a>
                </div>
                <!-- /Customer -->

                <!-- Select Date -->
                <div class="accordion" id="accordionMain2">
                  <a
                    href="javascript:void(0);"
                    class="w-100 collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="true"
                    aria-controls="collapseTwo"
                  >
                    <div class="card-header-new" id="headingTwo">
                      <h6 class="filter-title">
                        Select Date
                        <span class="float-end"
                          ><i class="fa-solid fa-chevron-down"></i
                        ></span>
                      </h6>
                    </div>
                  </a>

                  <div
                    id="collapseTwo"
                    class="collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample2"
                  >
                    <div class="card-body-chat">
                      <div class="form-group">
                        <label class="form-control-label">From</label>
                        <div class="cal-icon">
                          <datepicker
                            v-model="searchForm.from"
                            class="picker"
                            :editable="true"
                            :clearable="false"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label">To</label>
                        <div class="cal-icon">
                          <datepicker
                            v-model="searchForm.to"
                            class="picker"
                            :editable="true"
                            :clearable="false"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /Select Date -->

                <button
                  @click="resetSearchForm"
                  class="d-inline-flex align-items-center justify-content-center btn w-100 btn-primary"
                >
                  <span><i class="feather feather-refresh-ccw me-2"></i></span
                  >Reset
                </button>
              </b-form>
            </div>
          </div>
        </div>
        <!--/Add Asset -->

        <!-- Table -->
        <div class="row">
    			        <div class="col-md-3 mb-3">
                
          <div class="form-custom">
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="Search anything..."
             		v-model="searchForm.search"
            />
        
          </div>
        </div>
				
          <div class="col-sm-12">
            <div class="card-table">
              <div class="card-body">
                <div class="table-responsive">
                  <a-table
                    class="stripped table-hover"
                    :columns="columns"
                    :loading="isFetching"
                    :data-source="profitandloss"
                    :pagination="false"
                  >
                    <template #bodyCell="{ column, record, index }">
                      <template v-if="column.key === 'index'">
                        {{ index + 1 }}
                      </template>
                      <template v-else-if="column.key === 'date'">
                        {{ record.date }}
                      </template>
                      <template v-else-if="column.key === 'income'">
                        {{ useCurrency(record.income) }}
                      </template>
                      <template v-else-if="column.key === 'expense'">
                        {{ useCurrency(record.expense) }}
                      </template>
                      <template v-else-if="column.key === 'profit'">
                        {{ useCurrency(record.profit) }}
                      </template>
                      <template v-else-if="column.key === 'action'">
                        <div class="dropdown dropdown-action">
                          <a
                            href="javascript:;"
                            class="btn-action-icon"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            >Action</a
                          >
                          <div class="dropdown-menu dropdown-menu-right">
                            <ul>
                              <li>
                                <a
                                  class="dropdown-item"
                                  href="javascript:void(0);"
                                  ><i
                                    class="feather feather-download-cloud me-2"
                                  ></i
                                  >Generate report</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </template>
                    </template>
                  </a-table>
                </div>
                <div class="d-flex justify-content-end">
                  <a-pagination
                    class="mt-4"
                    :current="currentPage"
                    :total="total"
                    :page-size="perPage"
                    :show-size-changer="false"
                    :show-quick-jumper="false"
                    @change="handlePageChange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Table -->
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
  <!-- /Main Wrapper -->
</template>
<script setup>
import { onMounted, computed, ref, watch } from "vue";
import { useCurrency } from "@/assets/composables/currency";
import {
  formatDateToDashDigits,
  formatDateStrings,
} from "@/assets/composables/date";
import { useStore } from "vuex";

const store = useStore();
const isFetching = ref(false);
const currentPage = ref(1);
const perPage = ref(50);

const resetSearchForm = () => {
  searchForm.value = {
    search: "",
    from: formatDateStrings("2022-01-01"),
    to: new Date(),
  };
};

const searchForm = ref({
  search: "",
  from: formatDateStrings("2022-01-01"),
  to: new Date(),
});

watch(
  () => searchForm.value,
  (newValue) => {
    isFetching.value = true;
    let data = {
      start_date:
        newValue.from != "" ? formatDateToDashDigits(newValue.from) : "",
      end_date: newValue.to != "" ? formatDateToDashDigits(newValue.to) : "",
       query: newValue.search,
    };
    store.dispatch("reports/getProfitandLoss", data).then(() => {
      isFetching.value = false;
    });
  },
  { deep: true }
);

const handlePageChange = (page) => {
  currentPage.value = page;
};

watch(currentPage, (newValue) => {
  currentPage.value = newValue;
  getProfitandLoss();
});

const columns = [
  {
    title: "#",
    key: "index",
    sorter: true,
  },
  {
    title: "Month",
    key: "date",
    sorter: true,
  },
  {
    title: "Total Income",
    key: "income",
    sorter: true,
  },
  {
    title: "Total Expense",
    key: "expense",
    sorter: true,
  },
  {
    title: "Total Profit",
    key: "profit",
    sorter: true,
  },

  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];

const profitandloss = computed(() => {
  return store.getters["reports/profitsandloss"];
});
const total = computed(() => {
  return store.getters["reports/total"];
});

const getProfitandLoss = () => {
  isFetching.value = true;
  let data = {
    start_date: "2022-01-01",
    end_date: formatDateToDashDigits(new Date()),
  };
  store
    .dispatch("reports/getProfitandLoss", data)
    .then(() => {
      isFetching.value = false;
    })
    .catch(() => {
      isFetching.value = false;
    });
};

onMounted(() => {
  getProfitandLoss();
  if (document.querySelectorAll(".popup-toggle").length > 0) {
    document.querySelectorAll(".popup-toggle").forEach(function (el) {
      el.addEventListener("click", function () {
        document.querySelector(".toggle-sidebar").classList.add("open-filter");
      });
    });

    document.querySelectorAll(".sidebar-closes").forEach(function (el) {
      el.addEventListener("click", function () {
        document
          .querySelector(".toggle-sidebar")
          .classList.remove("open-filter");
      });
    });
  }
});
</script>
